import { Component, Input } from '@angular/core';
import { AvatarBackgroundSizes, AvatarShapes } from 'mojo-avatar';

import { CandidateAdapter, Skill } from '@shared/models';

@Component({
  selector: 'mojo-simple-candidate',
  templateUrl: './simple-candidate.component.html',
  styleUrls: ['./simple-candidate.component.scss'],
})
export class SimpleCandidateComponent {
  @Input() candidate: CandidateAdapter;
  @Input() softSkills: Array<Skill>;
  @Input() hardSkills: Array<Skill>;

  avatarPhotoShape = AvatarShapes.circle;
  avatarBackground = AvatarBackgroundSizes.cover;
}
